import React, { useEffect, useState } from "react";
import { Button, Divider, Menu, MenuItem } from "@material-ui/core";
import { IoMdArrowDropdown, IoMdArrowDropup} from "react-icons/io";

const SpecializationList = (props) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [displaySpeciality, setDisplaySpeciality] = useState([]);

    useEffect(() => {
        if(props?.uniqueSpecialData){
            setDisplaySpeciality(props?.uniqueSpecialData);
        }
    }, [props]);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        props.setSpec();
        props.setCancelSearch(false)
        setAnchorEl(null);
    };
    const handleSelect = (e) => {
        props.setSpec(e);
        props.setCancelSearch(false)
        setAnchorEl(null);
    };
    return (
        <div className="flexInline pointer">
            <Button 
                size="medium" 
                style={{ minWidth: "150px", display: "flex", justifyContent: "space-between", alignItems: "center" }}
                variant="outlined" 
                disableElevation 
                disableRipple
                color="primary" 
                endIcon={Boolean(anchorEl) ? <IoMdArrowDropup size={20} /> : <IoMdArrowDropdown size={20} />}
                onClick={handleClick}>
                { displaySpeciality?.includes(props.spec) && props.spec?.speciality ? props.spec?.speciality : "Specialization"}
            </Button>
            <div className="flexInline alignCenter">
                <Menu
                    id="demo-positioned-menu"
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={handleClose}
                    sx={{width:'200px'}}
                    PaperProps={{
                        elevation: 0,
                        sx: {
                            overflow: "visible",
                            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                            mt: 1.5,
                            "& .MuiAvatar-root": {
                                width: 32,
                                height: 32,
                                ml: -0.5,
                                mr: 1,
                            },
                            "&:before": {
                                content: '""',
                                display: "block",
                                position: "absolute",
                                top: 0,
                                right: 14,
                                width: 10,
                                height: 10,
                                bgcolor: "background.paper",
                                transform: "translateY(-50%) rotate(45deg)",
                                zIndex: 12999999,
                            },
                        },
                    }}
                    transformOrigin={{ horizontal: "right", vertical: -45 }}
                    anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                >
                    <MenuItem onClick={handleClose}>
                        <span className="fontweight">Specialization</span>
                    </MenuItem>
                    <Divider />
                    {displaySpeciality?.length > 0 && displaySpeciality?.map((item) => (
                        <MenuItem onClick={() => handleSelect(item)}>
                            <div className="flexRow alignCenter">
                                <div className="flexMinWidthRow">
                                    <span>{item.speciality}</span>
                                </div>
                            </div>
                        </MenuItem>
                    ))}
                </Menu>
            </div>
        </div>
    );
};
export default SpecializationList;
